/**
 * French labels for known audit action codes. Unknown actions fall back to
 * the raw code (often "METHOD /path" captured automatically).
 */
export const ACTION_LABELS = {
    CONFISCATE_REQUEST: "Demande de confiscation",
    CONFISCATE_APPROVE: "Confiscation approuvée",
    CONFISCATE_REJECT: "Confiscation rejetée",
    ACCESS_IBAN: "Accès IBAN",
    ACCESS_OCR: "Accès OCR",
    reset_reactivation: "Réinitialisation réactivation",
};

/**
 * Action codes considered sensitive (data access / irreversible), highlighted
 * in the table.
 */
export const SENSITIVE_ACTIONS = new Set([
    "ACCESS_IBAN", "ACCESS_OCR", "CONFISCATE_APPROVE", "CONFISCATE_REQUEST", "CONFISCATE_REJECT",
]);

/**
 * Returns the display label for an action code.
 * @param {string} action - The raw action code
 * @returns {string} A French label, or the raw code as fallback
 */
export function actionLabel(action) {
    return ACTION_LABELS[action] || action || "—";
}

/**
 * Suggested action filter options surfaced in the filter dropdown.
 */
export const ACTION_FILTER_OPTIONS = [
    { value: "", label: "Toutes les actions" },
    { value: "ACCESS_IBAN", label: "Accès IBAN" },
    { value: "ACCESS_OCR", label: "Accès OCR" },
    { value: "CONFISCATE_REQUEST", label: "Demande de confiscation" },
    { value: "CONFISCATE_APPROVE", label: "Confiscation approuvée" },
    { value: "CONFISCATE_REJECT", label: "Confiscation rejetée" },
];

/**
 * Audit log retention notice shown in the UI (server purges weekly).
 */
export const RETENTION_NOTICE = "Rétention : 1 an (purge automatique côté serveur). Accès lecture seule (Super Admin).";
